import { Divider, Box, Container, Chip } from '@mui/material'
import FeaturesGrid from './FeaturesGrid'
import GetStartedA from './GetStartedA'
import GetStartedB from './GetStartedB'

import { LogEventOnPageLoad } from '../../../components'
import { EVENTS } from '../../../constants'
const isA = true
function HomePage() {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        marginTop: 3,
      }}
    >
      <LogEventOnPageLoad event={EVENTS.home.landed} />
      <Container>
        {isA ? <GetStartedA /> : <GetStartedB />}
        {isA && (
          <Divider sx={{ mt: 7 }}>
            {' '}
            <Chip label="our key features" size="small" />{' '}
          </Divider>
        )}
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: isA ? 100 : -100,
            paddingBottom: 100,
          }}
        >
          <FeaturesGrid />
        </Box>
      </Container>
    </Box>
  )
}

export default HomePage
